import React from 'react';
import PropTypes from 'prop-types';
import {Row, Col} from 'react-flexa';
import {withStyles} from '@material-ui/core/styles';
import LeadForm from '../../LeadForm';
import Image from '../../components/Image';
import Typography from '../../components/Typography';
import BrandGrid from './BrandGrid';

const styles = theme => ({
  topSection: {
    height: '100%',
    position: 'relative',
    maxWidth: 1343,
    margin: '0 auto'
  },
  affairs: {
    margin: '2rem auto'
  },
  divider: {
    border: `1px solid #dadada`,
    width: 0,
    height: '90%',
    margin: 'auto'
  },
  image: {
    paddingTop: '.25rem',
    paddingBottom: '.25rem',
    maxWidth: 200,
    filter: 'brightness(0) invert(1)'
  },
  text: {
    color: '#FFFFFF',
  }
});

class TopSection extends React.Component {
  render() {
    const {classes} = this.props;
    return (
      <Row className={classes.topSection} gutter={0}>
        <Col xs={12} sm={12} md={4}>
          <LeadForm heading='Furnish Your Entire Home at ' emphasis='Wholesale' heading_continued=' Prices'/>
        </Col>
        <Col className={classes.affairs} xs={12} sm={12} md={7.5} style={{display: 'flex', alignItems:'flex-end'}}>
          <Row>
            <Col xs={12} sm={12} md={4}
                 style={{display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '0 2rem'}}>
              <Image className={classes.image} src="/homepage/consumer-affairs-white.svg"/>
            </Col>
            <Col xs={0} sm={0} md={8} style={{marginBottom: 20}}>
              <Typography variant='body2' className={classes.text}>
                Join our happy members and stop paying retail at traditional big box retailers. Save up to 72% off at
                DirectBuy and furnish the home of your dreams.
              </Typography>
            </Col>
            <Col xs={12} sm={12} md={0}>
              <Typography variant='body2' className={classes.text} style={{padding: '.25rem'}} align='center'>
                Join our happy members and stop paying retail at traditional big box retailers. Save up to 72% off at
                DirectBuy and furnish the home of your dreams.
              </Typography>
            </Col>
          </Row>
        </Col>
        <Col xs={12}>
          <Row>
            <Col xs={0} sm={0} md={4}>&nbsp;</Col>
            <Col xs={12} sm={12} md={8}>
              <hr style={{border: '1px solid rgba(224, 224, 224, .5)', marginRight: -40}}/>
            </Col>
          </Row>
          <BrandGrid/>
        </Col>
      </Row>
    );
  }
}

TopSection.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(TopSection)
